import styled, { keyframes } from 'styled-components';
import { Link as LinkR } from 'react-router-dom';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'
import { FaLock } from 'react-icons/fa';
import { GoEyeClosed } from 'react-icons/go'

export const HighLevelContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: top;
  align-items: top;
  color: #fff;
  background: ${({ lightBg }) => (lightBg ? '#f5f5f5' : '#f5f5f5')};
  padding: 0px 0;
  background-size: 100% auto;
  min-height: 90vh;

  @media screen and (max-width: 450px){
    min-height: 800px;
  }
`;

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const SpinningIcon = styled(AiOutlineLoading3Quarters)`
  margin-right: 5px;
  font-weight: bold;
  animation: 2s linear ${spin} infinite;
`

export const LockedIcon = styled(FaLock)`
  margin-right: 5px;
  font-weight: bold;
`

export const BuilderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: #f5f5f5;
`;

export const InfoContainer = styled.div`
  justify-content: center;
  align-items: center;
  color: #fff;
  background: ${({ lightBg }) => (lightBg ? '#f5f5f5' : '#010606')};
  background-size: 100% auto;
  padding: 0px 0px;
  // width: 50%

  @media screen and (max-width: 450px){
   width: 90%;
  }
`;

export const UserProjectionContainer = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: ${({ lightBg }) => (lightBg ? '#f5f5f5' : '#010606')};
  padding: 10px 20px;
  background-size: auto auto;
`;

export const SlateHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 60px;
  margin-top: 80px;
  align-items: center;
  background: #006ee6;
  border-width: thin;
  padding: 0px 24px;
  // max-width: 1100px;
`;

export const SavedContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 60px;
  align-items: center;
  background: silver;
  border-width: thin;
  padding: 0px 24px;
  // max-width: 1100px;
`;

export const SavedTeamRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  // height: 60px;
  align-items: center;
  background: white;
  border-width: thin;
  border-color: silver;
  border-style: solid;
  padding: 0px 24px;
  // max-width: 1100px;
`;

export const SavedPlayerRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  min-width: 1100px;

  @media screen and (max-width: 490px){
    min-width:auto
  }
`;


export const SlateHeaderInfo = styled.div`
  color: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
  justify-self: flex-start;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  margin-left: 24px;
  font-weight: bold;
  text-decoration: none;
  @media screen and (min-width: 490px){
    font-size: 1.5rem;
  }
`;

export const SavedHeaderInfo = styled.div`
  color: ${({ primary }) => (primary ? '#fff' : '#222831')};
  margin-top: 10px;
  margin-bottom: 10px;
  justify-self: flex-start;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  margin-left: 24px;
  font-weight: bold;
  text-decoration: none;
  @media screen and (min-width: 490px){
    font-size: 1.5rem;
  }
`;

export const SlateButton = styled.button`
  border-radius: 50px;
  margin-top: 5px;
  margin-bottom: 10px;
  background: ${({ primary }) => (primary ? '#010606' : '#222831')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 20px')};
  color: ${({ dark }) => (dark ? '#006ee6' : '#ffffff')};
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '12px')};
  font-weight: bold;
  outline: none;
  border: solid;
  border-width: thin;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-wrapper: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? '#006ee6' : '#006ee6')};
  }
`;

export const SavedHeaderButton = styled.button`
  border-radius: 50px;
  margin-top: 5px;
  margin-bottom: 10px;
  background: ${({ primary }) => (primary ? '#010606' : '#222831')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 20px')};
  color: ${({ dark }) => (dark ? '#006ee6' : '#ffffff')};
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '12px')};
  font-weight: bold;
  outline: none;
  border: solid;
  border-width: thin;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-wrapper: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? '#006ee6' : '#006ee6')};
  }
`;

export const SavedHeaderCircle = styled.circle`
  display: flex;
  width: 16px;
  height: 16px;
  background-color: #ffffff;
  color: #222831;
  border-radius: 50%;
  justify-content: center;
  margin-left: 6px
`

export const SavedHeaderClose = styled(GoEyeClosed)`
padding-left: 12px;
margin-right: 5px;
font-weight: bold;
`

export const SavedPlayerRow = styled.div`
  display: flex;
  height: 30px;
  background-color: #222831;
  border-radius: 12px;
  align-items: center;
  justify-content: space-between;
  padding: 2px;
  margin: 2px ;
  max-width: auto;
  min-width: 1100px;

  @media screen and (max-width: 490px){
    min-width: 350px
  }
`;

export const SavedPlayerName = styled.text`
  color: #fff;
  align: left;
`;

export const SavedPlayerDetails = styled.div`
  color: #fff;
  align-items: left;
  justify-content: space-evenly
`;

export const SavedPlayerItem = styled.text`
  color: #fff;
  align: left;
  margin-right: 20px
`;

export const TeamContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 200px); /* 3 columns of 200px each */
  grid-gap: 20px; /* optional spacing between items */
  justify-content: center; /* optional: center the grid horizontally */
  
  @media screen and (max-width: 460px) {
  grid-template-columns: repeat(3, 140px); /* 3 columns of 200px each */
    grid-gap: 2px;
    padding: 2px 2px;
  }
`

export const TeamCardContainer = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  // border-right-style: solid;
  // border-right-color: #006ee6;
  // border-right-width: 2px;
  grid-template-columns: 130px;
  grid-gap: 10px;
  
  @media screen and (min-width: 490px) {
    grid-template-columns: 200px;
    padding: 10px 10px;
  }
`;

export const CardContainer = styled.div`
   display: grid;
   margin: 20px;
   grid-template-columns: repeat(3, 300px); /* 3 columns of 200px each */
   grid-gap: 20px; /* optional spacing between items */
   justify-content: center; /* optional: center the grid horizontally */
   overflow-y: scroll;

  @media screen and (max-width: 460px) {
    grid-template-columns: repeat(3, 140px); /* 3 columns of 200px each */
    grid-gap: 12px;
    padding: 12px 12px;
  }
`;

export const UserProjectionCardContainer = styled.div`
  display: grid;
  padding: 20px 0;
  grid-gap: 20px;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;

  @media screen and (min-width: 490px) { 
    grid-template-columns: ${({ singleProjection }) => (singleProjection ? '300px' : '300px 300px 300px')};
  }
`;

export const TeamCard = styled.div`
  background-color: #000;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.7);
  color: white;
  min-height:140px;
  margin-bottom: 5px;
  @media screen and (min-width: 490px) { 
    margin-bottom: 12px;
  }
`;

export const SlotCard = styled.div`
  background-color: transparent; /* transparent background */
  border: 2px solid #006ee6;      /* blue border */
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  color: white;
  margin-bottom: 12px;
  box-shadow: 0 0 10px rgba(0, 110, 230, 0.3); /* optional glow effect */
  display: flex;
  flex-direction: column;
  min-height: 140px;
  @media screen and (max-width: 490px) { 
    margin-bottom: 5px;
  }
`;


export const Card = styled.div`
  background-color: #222831;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.7);
  color: white;
  min-width:120px;

  @media screen and (min-width:490px){
    height: 200px;
  }
`;

export const ProjectionCard = styled.div`
  background-color: #222831;
  height: auto;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.7);
  color: white;

  @media screen and (max-width:490px){
    min-width: 280px;
  }
`;

export const Column = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col1;
`;

export const InfoWrapper = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  z-index: 1;
  height: 860px;
  width: 100%;
  max-width: 1100px;
  margin-right: auto;
  margin-left: auto;
  padding: 0 24px;
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  text-align: center;
  align-items: center;
`;

export const TopLine = styled.div`
  color: #006ee6;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 4px;
  margin-top: 2px;
  
  font-size: 10px;

  @media screen and (min-width: 490px){
    font-size: 12px;
    margin-top: 5px;
    margin-bottom: 16px;
  }
`;

export const Heading = styled.h1`
  margin-bottom: 12px;
  font-size: 12px;
  line-height: 1.1;
  font-weight: 600;
  text-align: center;
  color: ${({ lightText }) => (lightText ? '#f7f8fa' : '#010606')};

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;

export const HeadingHelpersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 600px;

  
  @media screen and (max-width: 480px) {
    flex-direction: ${({ swap }) => (swap ? 'column' : 'row')};
    width: 300px;
  }
`

export const VStack = styled.div`
  display: flex;
  flex-direction: column;
`
export const Subtitle = styled.p`
  max-width: 440px;
  margin-bottom: 35px;
  font-size: 12px;
  line-height: 24px;
  align-items: center;
  color: ${({ darkText }) => (darkText ? '#010606' : '#fff')};
`;

export const BtnWrap = styled.div`
  display: flex;
  justify-content: ;
  align-items: center;
`;

export const ImgWrap = styled.div`
  justify-content: center;
  align-items: center;
  max-width: 555px;
  height: 100%;
`;

export const Img = styled.img`
  justify-content: center;
  height: 160px;
  width: 160px;
  border-radius: 50%;
  border: 5px solid #272133;
  margin-top: 20px;
  box-shadow: 0 10px 50px #006ee6;
`;

export const Form = styled.form`
  background: #f5f5f5;
  height: auto;
  display: grid;
  justify-content: center;
`;

export const FormH1 = styled.h1`
  margin-top: 10px;
  margin-bottom: 10px;
  color: #006ee6;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
   @media screen and (max-width: 450px) {
    margin-bottom: 2px;
  }
`;

export const FormH4 = styled.h4`
  padding: 0px 0px;
  margin: 0px;
  font-size: 12px;
  color: ${({ errorText }) => (errorText ? 'red' : '#f5f5f5')};
  font-weight: bold;
  text-align: center;
`;

export const ValueWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media screen and (min-width: 490px){
    justify-content: center;
  }
`;

export const FormInfoText = styled.h4`
  padding: 0px 0px;
  margin: 0px;
  margin-right:10px;
  color: #010606;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
`;

export const FormInfoValue = styled.h4`
  padding: 0px 0px;
  margin: 0px;
  color: ${({ errorText }) => (errorText ? '#006ee6' : 'red')};
  font-size: 16px;
  font-weight: bold;
  justify-content: center;
  text-align: center;
`;

export const FormInput = styled.input`
  border: none;
  border-radius: 4px;
  padding: 12px 12px;
  margin-left: 12px;
  @media screen and (min-width:490px){
    padding: 16px 16px;
  }
`;

export const UserProjectionInput = styled.input`
  padding: 8px 8px;
  border: none;
  border-radius: 2px;
  text-align: center;
  margin-top: 20px;
  font-size: 16px;
  @media screen and (max-width:490px){
    max-width: 100px;
  }
`;

export const ErrorText = styled.text`
  text-align: center;
  margin-top: 12px;
  color: red;
  font-size: 14px;
`;

export const BtnLink = styled(LinkR)`
  border-radius: 50px;
  background: #006ee6;
  white-space: nowrap;
  padding: 10px 22px;
  color: #010606;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #010606;
  }
`;

export const FilterWrap = styled.div`
  display: flex;
  flex-direction: row;
  color: #fff;
  padding: 10px 0;
  background-size: 100% auto;
  align-items: center;
  justify-content: center;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: gray;

  @media screen and (min-width: 490px){
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Select = styled.select`
  width: auto;
  height: 42px;
  background: white;
  color: gray;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  option {
    color: black;
    background: white;
    display: flex;
    white-space: pre;
    min-height: 20px;
    padding: 0px 2px 1px;
  }
  margin-top: 12px;
  @media screen and (min-width: 490px){
    margin: auto;
    margin-left: 10px;
  }
`;

export const ButtonWrap = styled.div`
  display: flex;
  padding-top: 6px;
  justify-content: space-between;
  max-width: auto;
  height: 100%;
`;

export const NextButton = styled.button`
  border-radius: 50px;
  background: ${({ primary }) => (primary ? '#006ee6' : '#222831')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 30px')};
  color: ${({ dark }) => (dark ? '#006ee6' : '#ffffff')};
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '16px')};
  outline: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  margin-left: 8px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? '#006ee6' : '#ffffff')};
  }

  @media screen and (max-width: 500px){
    margin-top: 4px;
  }
`;

export const SelectButton = styled.button`
  border-radius: 50px;
  margin-top: 5px;
  margin-bottom: 10px;
  background: ${({ primary }) => (primary ? '#010606' : '#222831')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 20px')};
  color: ${({ dark }) => (dark ? '#006ee6' : '#ffffff')};
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '12px')};
  font-weight: bold;
  outline: none;
  border: solid;
  border-width: thin;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-wrapper: center;
  transition: all 0.2s ease-in-out;
  justify-self: center;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? '#006ee6' : '#222831')};
  }

  
  @media screen and (max-width: 500px){
    margin-top: 0px;
  }
`;

export const ProjectionCardButtonLeft = styled.button`
  border-radius: 50px;
  margin-top: 5px;
  margin-bottom: 10px;
  background: ${({ primary }) => (primary ? '#010606' : '#222831')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 20px')};
  color: ${({ dark }) => (dark ? '#006ee6' : '#ffffff')};
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '12px')};
  font-weight: bold;
  outline: none;
  border: solid;
  border-width: thin;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-wrapper: center;
  transition: all 0.2s ease-in-out;
  margin-right: 20px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? '#006ee6' : '#006ee6')};
  }
`;

export const ProjectionCardButtonRight = styled.button`
  border-radius: 50px;
  margin-top: 5px;
  margin-bottom: 10px;
  background: ${({ primary }) => (primary ? '#010606' : '#222831')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 25px')};
  color: ${({ dark }) => (dark ? '#006ee6' : '#ffffff')};
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '12px')};
  font-weight: bold;
  outline: none;
  border: solid;
  border-width: thin;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-wrapper: center;
  transition: all 0.2s ease-in-out;
  margin-left: 20px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? '#006ee6' : '#006ee6')};
  }
`;

export const LoadButton = styled.button`
  border-radius: 50px;
  margin-top: 5px;
  margin-bottom: 5px;
  background: ${({ primary }) => (primary ? '#006ee6' : '#222831')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 20px')};
  color: ${({ dark }) => (dark ? '#006ee6' : '#ffffff')};
  font-size: ${({ fontBig }) => (fontBig ? '20px' : '12px')};
  font-weight: bold;
  outline: none;
  border: solid;
  border-width: thin;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-wrapper: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? '#006ee6' : '#006ee6')};
  }
`;

export const ModalBanner = styled.div`
  width: 200px;
  align-text: center;
`

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContainer = styled.div`
  background: white;
  border-color: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const ModalHeader = styled.h2`
  margin: 0;
  margin-bottom: 10px;
  color: blue
`;

export const ModalBody = styled.div` 
 margin-bottom: 20px; 
 display: flex; // Added flex display
 justify-content: space-between; // Space between columns 
`;

export const ModalColumn = styled.div` 
 flex: 1; // Each column takes equal space 
 padding: 0 10px; // Add some space between columns 
 color: black;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ModalButton = styled.button`
  padding: 6px 12px;
  background-color: #010606;
  color: white;
  border-radius: 1px;
  border-width: 1px;
  cursor: pointer;
  margin-bottom: 6px;

  &:hover {
      background-color: #006ee6;
  }
`;


export const BrainButton = styled.button`
  position: fixed;
  bottom: 300px;
  left: 28px;
  background-color: #006ee6;
  color: white;
  border: none;
  border-radius: 50%;
  padding: 12px;
  font-size: 20px;
  cursor: pointer;
  z-index: 1100;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 600px) {
    bottom: 70px;
    left: 10px;
    padding: 10px;
    font-size: 20px;
  }
`;